import { render, staticRenderFns } from "./ImmediateMessagePopup.vue?vue&type=template&id=d4db4cca&scoped=true"
import script from "./ImmediateMessagePopup.vue?vue&type=script&lang=js"
export * from "./ImmediateMessagePopup.vue?vue&type=script&lang=js"
import style0 from "./ImmediateMessagePopup.vue?vue&type=style&index=0&id=d4db4cca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4db4cca",
  null
  
)

export default component.exports